// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__lstag","tooltip__label":"styles_tooltip__label__B1zy-","tooltip__value":"styles_tooltip__value__3dEIs"};